import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import PopConfirm from './_PopConfirm';
import PopClassHistory from '../student/_PopClassHistory'; //수업 히스토리 팝업
function PopFinishReport(props) {
  const {open, close} = props;
  const [modalConfirm, setModalConfirm] = useState(false);
  const [selectedOption, setSelectedOption] = useState('rdoState01');
  return (
    <Modal open={open} close={close} type="com_input com_class_retister pop_finish_report">
      <h2 className="pop_tit">취소/중단/인계/종료 보고서</h2>
      <div className="content_container com_input_sec">
        <div className="com_flex_row first">
          <section className="search_cont">
            <section className="search search_top">
              <input type="search" placeholder="학생명 검색" className="input xs" />
              <button className="com_btn gray ws xs icon_search"></button>
            </section>
            <section className="com_input_wrap flex_between flex_row">
              <input type="text" placeholder="김학생" className="input" />
              <select className="select full">
                <option value="수업 선택">수업 선택</option>
              </select>
            </section>
            <div className="com_board_box board_item__scroll">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    <span className="desc"> (고3ㆍ경기고등학교ㆍ본사) </span>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">전화번호</span>
                  <div className="cont">
                    <p className="txt">010-1234-233</p>
                  </div>
                </div>
                <div className="info">
                  <span className="tit">부모폰</span>
                  <div className="cont">
                    <p className="txt">
                      <span>부)010-1234-233</span>
                      <span className="dot" />
                      <span>모)010-1234-233</span>
                    </p>
                  </div>
                </div>
                <div className="info">
                  <span className="tit">홍보</span>
                  <span className="cont">
                    <button className="btn_link">김홍보302</button>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">
                    <button className="btn_link">김담임302</button>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">교사</span>
                  <span className="cont">
                    <button className="btn_link">김교사302</button>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 방법</span>
                  <span className="cont">대면 l 30분</span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont">과탐</span>
                </div>
                <div className="info">
                  <span className="tit">수업상세</span>
                  <span className="cont">사회문화, 경제, 밥과정서</span>
                </div>
                <div className="info">
                  <span className="tit">기수</span>
                  <span className="cont">2기</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">회차/타임</span>
                  <span className="cont">45회 / 2T</span>
                </div>
                <div className="info">
                  <span className="tit">1회 수업료</span>
                  <span className="cont">45,000</span>
                </div>
                <div className="info">
                  <span className="tit">수업료</span>
                  <span className="cont">2,500,000</span>
                </div>
                <div className="info">
                  <span className="tit">DC코드 / 할인금액</span>
                  <span className="cont">50,000 / 2기 수업으로</span>
                </div>
                <div className="info">
                  <span className="tit">실 수업료</span>
                  <span className="cont com_blue_txt">2,450,000</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">완성여부</span>
                  <span className="cont">Y</span>
                </div>
                <div className="info">
                  <span className="tit">비교수업</span>
                  <span className="cont">N</span>
                </div>
                <div className="info">
                  <span className="tit">첫 수업일</span>
                  <span className="cont">2023.05.05 19:30</span>
                </div>
                <div className="info">
                  <span className="tit">마지막 수업일</span>
                  <span className="cont">2023.05.09 19:30</span>
                </div>
                <div className="info">
                  <span className="tit">수업 장소</span>
                  <span className="cont">경기도 수원시 팔달구 팔달로1465 모여라 빌딩 203호</span>
                </div>
                <div className="info">
                  <span className="tit">진행 수업 수 </span>
                  <span className="cont com_blue_txt">45 / 65</span>
                </div>
                <div className="info">
                  <span className="tit">진행률</span>
                  <span className="cont">65%</span>
                  <button className="btn_report">출석부 보기</button>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    <span className="desc"> (고3ㆍ경기고등학교ㆍ본사) </span>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">전화번호</span>
                  <div className="cont">
                    <p className="txt">010-1234-233</p>
                  </div>
                </div>
                <div className="info">
                  <span className="tit">부모폰</span>
                  <div className="cont">
                    <p className="txt">
                      <span>부)010-1234-233</span>
                      <span className="dot" />
                      <span>모)010-1234-233</span>
                    </p>
                  </div>
                </div>
                <div className="info">
                  <span className="tit">홍보</span>
                  <span className="cont">
                    <button className="btn_link">김홍보302</button>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">
                    <button className="btn_link">김담임302</button>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">교사</span>
                  <span className="cont">
                    <button className="btn_link">김교사302</button>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 방법</span>
                  <span className="cont">대면 l 30분</span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont">과탐</span>
                </div>
                <div className="info">
                  <span className="tit">수업상세</span>
                  <span className="cont">사회문화, 경제, 밥과정서</span>
                </div>
                <div className="info">
                  <span className="tit">기수</span>
                  <span className="cont">2기</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">회차/타임</span>
                  <span className="cont">45회 / 2T</span>
                </div>
                <div className="info">
                  <span className="tit">1회 수업료</span>
                  <span className="cont">45,000</span>
                </div>
                <div className="info">
                  <span className="tit">수업료</span>
                  <span className="cont">2,500,000</span>
                </div>
                <div className="info">
                  <span className="tit">DC코드 / 할인금액</span>
                  <span className="cont">50,000 / 2기 수업으로</span>
                </div>
                <div className="info">
                  <span className="tit">실 수업료</span>
                  <span className="cont com_blue_txt">2,450,000</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">완성여부</span>
                  <span className="cont">Y</span>
                </div>
                <div className="info">
                  <span className="tit">비교수업</span>
                  <span className="cont">N</span>
                </div>
                <div className="info">
                  <span className="tit">첫 수업일</span>
                  <span className="cont">2023.05.05 19:30</span>
                </div>
                <div className="info">
                  <span className="tit">마지막 수업일</span>
                  <span className="cont">2023.05.09 19:30</span>
                </div>
                <div className="info">
                  <span className="tit">수업 장소</span>
                  <span className="cont">경기도 수원시 팔달구 팔달로1465 모여라 빌딩 203호</span>
                </div>
                <div className="info">
                  <span className="tit">진행 수업 수 </span>
                  <span className="cont com_blue_txt">45 / 65</span>
                </div>
                <div className="info">
                  <span className="tit">진행률</span>
                  <span className="cont">65%</span>
                  <button className="btn_report">출석부 보기</button>
                </div>
              </div>
            </div>
            <div className="com_comment_wrap">
              <div className="com_input_wrap flex_between">
                <select className="select">
                  <option value="2수업 상태 변경">2수업 상태 변경</option>
                </select>
                  <select className="select ">
                    <option value="사유1">사유1</option>
                  </select>
                  <select className="select ">
                    <option value="사유2">사유2</option>
                  </select>
              </div>
              <textarea className="textarea" placeholder="사유 입력"></textarea>
              <div className="refund">
                <strong className="total com_blue_txt">환불금액 : 465,000원</strong>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_radio_wrap center padding_y">
              <input type="radio" name="rdoState" id="rdoState01" className="com_chk circle" checked={selectedOption === 'rdoState01'} onChange={() => setSelectedOption('rdoState01')} />
              <label htmlFor="rdoState01">환불</label>

              <input type="radio" name="rdoState" id="rdoState02" className="com_chk circle" checked={selectedOption === 'rdoState02'} onChange={() => setSelectedOption('rdoState02')} />
              <label htmlFor="rdoState02">수업변경</label>

              <input type="radio" name="rdoState" id="rdoState03" className="com_chk circle" checked={selectedOption === 'rdoState03'} onChange={() => setSelectedOption('rdoState03')} />
              <label htmlFor="rdoState03">기존 수업으로 이동</label>
            </div>
          </section>
          <section className="detail_cont">
            {selectedOption === 'rdoState01' && (
              <>
                <div className="com_info center">
                  <span className="desc"> 환불할 금액을 입력해 주세요.</span>
                </div>
                <div className="com_board_box">
                  <div className="board_item">
                    <div className="info">
                      <span className="tit">단말기</span>
                      <span className="cont">78,000 </span>
                    </div>
                    <div className="info">
                      <span className="tit">카드</span>
                      <span className="cont">45,000 </span>
                    </div>
                    <div className="info">
                      <span className="tit">가상계좌</span>
                      <span className="cont">78,000 </span>
                    </div>
                    <div className="info">
                      <span className="tit">현금</span>
                      <span className="cont">78,000 </span>
                    </div>
                    <div className="info">
                      <span className="tit">위약금</span>
                      <span className="cont">
                        <input type="text" className="input com_red_txt ws" defaultValue={`- 60,000`} />
                      </span>
                    </div>
                    <div className="info">
                      <span className="tit">수수료</span>
                      <span className="cont">
                        <input type="text" className="input com_red_txt ws" defaultValue={`- 60,000`} />
                      </span>
                    </div>
                    <div className="info">
                      <span className="tit">총 환불 금액</span>
                      <span className="cont com_blue_txt">798, 000</span>
                    </div>
                  </div>
                </div>
                <div className="detail_tit dot">환불 방법 선택</div>
                <table className="com_board_list type_row">
                  <colgroup>
                    <col width="130" />
                    <col width="auto" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>카드 취소 금액</th>
                      <td>
                        <input type="text" className="input com_blue_txt ws" defaultValue={`60,000`} />
                      </td>
                    </tr>
                    <tr>
                      <th>무통장 입금</th>
                      <td>
                        <div className="com_input_wrap">
                          <input type="text" className="input com_blue_txt ws" defaultValue={`60,000`} />
                        </div>
                        <div className="com_input_wrap flex_row">
                          <input type="text" className="input" placeholder="은행명 입력" />
                          <input type="text" className="input" placeholder="계좌주 입력" />
                          <input type="text" className="input" placeholder="계좌 번호 입력" />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="detail_tit dot">환불 사유 </div>
                <div className="com_board_box">
                  <textarea className="textarea" placeholder="환불 사유 메모 입력 (100자)"></textarea>
                </div>
                <div className="btn_container">
                  <button className="com_btn orange xs">등록</button>
                </div>
              </>
            )}
            {selectedOption === 'rdoState02' && (
              <>
                <div className="com_info center">
                  <span className="desc"> 변경할 수업을 입력해 주세요.</span>
                </div>
                <ClassSet />
                <div className="btn_container">
                  <button className="com_btn orange xs">등록</button>
                </div>
              </>
            )}
            {selectedOption === 'rdoState03' && (
              <>
                <div className="com_info center">
                  <span className="desc">이동할 수업을 선택해 주세요.</span>
                </div>
                <div className="com_board_box">
                  <div className="board_item">
                    <div className="check">
                      <input type="radio" name="rdoChangeClass" id="rdoChangeClass1" className="com_chk circle" />
                      <label htmlFor="rdoChangeClass1">
                        <p className="cont bold">수업 1ㆍ최교사123ㆍ2기(2T 24회) </p>
                        <div className="info">
                          화상 / 영어 / 고1일반 / 기본영어 / 완성수업N 14주 / 비교수업N / 2T / <br />
                          수업료 : 780,000
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="board_item">
                    <div className="check">
                      <input type="radio" name="rdoChangeClass" id="rdoChangeClass1" className="com_chk circle" />
                      <label htmlFor="rdoChangeClass1">
                        <p className="cont bold">수업 2ㆍ최교사123ㆍ2기(2T 24회) </p>
                        <div className="info">
                          화상 / 영어 / 고1일반 / 기본영어 / 완성수업N 14주 / 비교수업N / 2T / <br />
                          수업료 : 780,000
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="btn_container">
                  <button className="com_btn orange xs">등록</button>
                </div>
              </>
            )}
          </section>
        </div>
      </div>

      <PopConfirm open={modalConfirm} close={() => setModalConfirm(false)} />
    </Modal>
  );
}
const ClassSet = () => {
  //클래스 추가
  const [AdmissionChk, setAdmissionChk] = useState(1); //수시선택
  const [isOpen, setIsOpen] = useState(false);
  const [modalOpenClassHistory, setModalOpenClassHistory] = useState(false); //수업히스토리 팝업
  const classOpen = (event) => {
    // 👇️ toggle isActive state on click
    setIsOpen((current) => !current);
  };
  return (
    <div className="class_list">
      <div className={`class_item  ${isOpen ? 'open' : ''}`}>
        <button type="button" className="icon_arrow_down" onClick={classOpen}></button>
        <div className="com_sec_tit__wrap">
          <p className="com_sec_tit dot">
					수업 1ㅣ김교사987ㅣ1기(1T 12회) <button className="btn_del_file"></button>
          </p>
        </div>
        <div className="top_btn_wrap">
          <button onClick={() => setModalOpenClassHistory(true)} className="com_btn xs black btn_plus_orange btn_history">
            수업 히스토리
          </button>
          <button className="com_btn xs lightOrange btn_list">수업료 단가표</button>
        </div>
        <div className="toggle_cont">
          <p className="summary">화상 / 영어 / 고1일반 / 기본영어 / 완성수업N 14주 / 비교수업N / 2T / 수업료 : 780,000</p>
          <div className="table_wrap">
            <table className="com_board_list type_row">
              <colgroup>
                <col width="140px" />
                <col width="250px" />
                <col width="140px" />
                <col width="250px" />
              </colgroup>
              <tbody>
                <tr>
                  <th>영업 정보</th>
                  <td>
                    <select className="select">
                      <option>선택</option>
                    </select>
                  </td>
                  <th>영업 상세</th>
                  <td>비회원 문이</td>
                </tr>
                <tr>
                  <th>인센티브 지급자</th>
                  <td colSpan="3">
                    <div className="com_input_wrap flex_row">
                      <section className="com_board_search">
                        <article className="search full">
                          <input type="search" placeholder="교사, 담임, 홍보 검색" className="input s type_search" />
                          <button className="com_btn gray ws icon_search"></button>
                        </article>
                      </section>
                      <div className="selected_item__wrap">
                        <p className="selected_item">
                          김교사 <button className="btn_del_file"></button>
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>수업소속 선택</th>
                  <td className="td_left" colSpan={3}>
                    <div className="check">
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-01" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-01" onClick={() => setAdmissionChk(1)}>
                        본사
                      </label>
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-02" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-02" onClick={() => setAdmissionChk(1)}>
                        부산
                      </label>
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-03" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-03" onClick={() => setAdmissionChk(1)}>
                        원격과세
                      </label>
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-04" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-04" onClick={() => setAdmissionChk(1)}>
                        원격비과세
                      </label>
                      <input type="radio" name="class_register_rdo01" id="class_register_rdo01-05" className="com_chk circle" />
                      <label htmlFor="class_register_rdo01-05" onClick={() => setAdmissionChk(0)}>
                        수시
                      </label>
                    </div>
                  </td>
                </tr>
                {AdmissionChk === 0 ? ( //수시 선택
                  <>
                    <tr>
                      <th rowSpan={4}>수업 선택</th>
                      <td className="td_left border_left" colSpan={3}>
                        <div className="check">
                          <input type="radio" name="rdo2" id="rdo2-01" className="com_chk circle" />
                          <label htmlFor="rdo2-01">생기부디자인</label>
                          <input type="radio" name="rdo2" id="rdo2-02" className="com_chk circle" />
                          <label htmlFor="rdo2-02">면접</label>
                          <input type="radio" name="rdo2" id="rdo2-03" className="com_chk circle" />
                          <label htmlFor="rdo2-03">자소서</label>
                          <input type="radio" name="rdo2" id="rdo2-04" className="com_chk circle" />
                          <label htmlFor="rdo2-04">논술</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        <div className="check">
                          <input type="radio" name="rdo3" id="rdo3-01" className="com_chk circle" />
                          <label htmlFor="rdo3-01">정시컨설팅</label>
                          <input type="radio" name="rdo3" id="rdo3-02" className="com_chk circle" />
                          <label htmlFor="rdo3-02">수시컨설팅</label>
                          <input type="radio" name="rdo3" id="rdo3-03" className="com_chk circle" />
                          <label htmlFor="rdo3-03">수시제안컨설팅</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        <p className="com_red_txt">* 이수업은 연장 수업입니다. (*2024, 01, 12 같은 수업을 진행하였습니다.)</p>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        <div className="check">
                          <input type="radio" name="rdo4" id="rdo4-01" className="com_chk circle" />
                          <label htmlFor="rdo4-01">단품 수업</label>
                          <input type="radio" name="rdo4" id="rdo4-02" className="com_chk circle" />
                          <label htmlFor="rdo4-02">세트 수업</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>상품명</th>
                      <td colSpan={3}>
                        <select>
                          <option>선택</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>수업회차</th>
                      <td colSpan={3}>
                        <select className="select">
                          <option>1회</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>수업 방법</th>
                      <td colSpan={3}>
                        <div className="check">
                          <input type="radio" name="class_register_rdo02" id="class_register_rdo02-01" className="com_chk circle" />
                          <label htmlFor="class_register_rdo02-01">대면 수업</label>
                          <input type="radio" name="class_register_rdo02" id="class_register_rdo02-02" className="com_chk circle" />
                          <label htmlFor="class_register_rdo02-02">화상 수업</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th rowSpan={2}>수업1</th>
                      <td colSpan={3}>* 1회수업시간 : 90분 * 수업체크 방법 : 보고서작성 * 수업방법 : 1:1수업</td>
                    </tr>
                    <tr>
                      <td colSpan={3}>* 수업단가 : 250,000 * 지급방법 : 정액제 * 지급메인 : 25,000 * 지급서브 : 10,000 비과세</td>
                    </tr>
                  </>
                ) : AdmissionChk === 1 ? ( //그외
                  <>
                    <tr>
                      <th rowSpan={4}>수업 선택</th>
                      <td className="td_left border_left" colSpan={3}>
                        <div className="check">
                          <input type="radio" name="rdo1" id="rdo1_01" className="com_chk circle" />
                          <label htmlFor="rdo1_01">국어</label>
                          <input type="radio" name="rdo1" id="rdo1_02" className="com_chk circle" />
                          <label htmlFor="rdo1_02">영어</label>
                          <input type="radio" name="rdo1" id="rdo1_03" className="com_chk circle" />
                          <label htmlFor="rdo1_03">수학</label>
                          <input type="radio" name="rdo1" id="rdo1_04" className="com_chk circle" />
                          <label htmlFor="rdo1_04">사탐</label>
                          <input type="radio" name="rdo1" id="rdo1_04" className="com_chk circle" />
                          <label htmlFor="rdo1_04">과탐</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="td_left border_left" colSpan={3}>
                        <select className="select">
                          <option value="고3 이상">고3 이상</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td className="td_left border_left" colSpan={3}>
                        <div className="check">
                          <input type="checkbox" name="chk" id="chk_01" className="com_chk" />
                          <label htmlFor="chk_01">사회문화</label>
                          <input type="checkbox" name="chk" id="chk_02" className="com_chk" />
                          <label htmlFor="chk_02">경제</label>
                          <input type="checkbox" name="chk" id="chk_03" className="com_chk" />
                          <label htmlFor="chk_03">정치와 법</label>
                          <input type="checkbox" name="chk" id="chk_04" className="com_chk" />
                          <label htmlFor="chk_04">윤리와사상</label>
                          <input type="checkbox" name="chk" id="chk_05" className="com_chk" />
                          <label htmlFor="chk_05">생활과윤리</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td className="td_left border_left" colSpan={3}>
                        <div className="check">
                          <input type="checkbox" name="chk" id="chk_06" className="com_chk" />
                          <label htmlFor="chk_06">한국사</label>
                          <input type="checkbox" name="chk" id="chk_06" className="com_chk" />
                          <label htmlFor="chk_06">세계사</label>
                          <input type="checkbox" name="chk" id="chk_08" className="com_chk" />
                          <label htmlFor="chk_08">동아시아사</label>
                          <input type="checkbox" name="chk" id="chk_09" className="com_chk" />
                          <label htmlFor="chk_09">한국지리</label>
                          <input type="checkbox" name="chk" id="chk_10" className="com_chk" />
                          <label htmlFor="chk_10">세계지리</label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>완성형수업</th>
                      <td className="td_left">
                        <div className="com_input_wrap flex_between flex_row">
                          <input type="checkbox" name="chk3" id="chk3_01" className="com_chk " />
                          <label htmlFor="chk3_01">Y</label>
													<input type="text" className="input ws" value="8회" />
                        </div>
                      </td>
                      <th>타임</th>
                      <td className="td_left">
                        <select className="select">
                          <option value="2T">2T</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>동시수업</th>
                      <td className="td_left">
                        <section className="com_board_search">
                          <article className="search full">
                            <input type="search" placeholder="학생 검색" />
                            <button className="com_btn gray ws xs icon_search"></button>
                          </article>
                        </section>
                      </td>
                      <th>1회 수업시간</th>
                      <td className="td_left">
                        <select className="select">
                          <option value="30분">30분</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th>동시수업 인원</th>
                      <td>
                        <div className="selected_item__wrap">
                          <p className="selected_item">
                            김학생103 <button className="btn_del_file"></button>
                          </p>
                          <p className="selected_item">
                            김학생103 <button className="btn_del_file"></button>
                          </p>
                        </div>
                      </td>
                      <th>1회 수업료</th>
                      <td className="td_left">230,000</td>
                    </tr>
                    <tr>
                      <th>교사지목</th>
                      <td>
                        <div className="com_input_wrap flex_row">
                          <input type="checkbox" className="com_chk" />
                          <label />
                          <section className="com_board_search">
                            <article className="search full">
                              <input type="search" placeholder="교사 검색" />
                              <button className="com_btn gray ws xs icon_search"></button>
                            </article>
                          </section>
                        </div>
                      </td>
                      <th>수업료</th>
                      <td className="td_left td_point">
                        <b className="com_blue_txt">780,000</b>
                      </td>
                    </tr>
                  </>
                ) : (
                  <></>
                )}
                {AdmissionChk === 0 ? ( //수시 선택
                  <tr>
                    <th>총 수업료</th>
                    <td className="td_left td_point" colSpan={3}>
                      <b className="com_blue_txt">7230,000</b>
                    </td>
                  </tr>
                ) : (
                  <></>
                )}
                <tr>
                  <th>메모</th>
                  <td colSpan={3} className="td_left">
                    <textarea />
                  </td>
                </tr>
                <tr>
                  <th>수업가능일</th>
                  <td colSpan={3} className="td_left">
                    <div className="com_input_wrap flex_row">
                      <div className="com_check_date">
                        <input type="checkbox" className="chk_date" id="mon" />
                        <label htmlFor="mon">월</label>
                        <input type="checkbox" className="chk_date" id="tue" />
                        <label htmlFor="tue">화</label>
                        <input type="checkbox" className="chk_date" id="wed" />
                        <label htmlFor="wed">수</label>
                        <input type="checkbox" className="chk_date" id="thu" />
                        <label htmlFor="thu">목</label>
                        <input type="checkbox" className="chk_date" id="fri" />
                        <label htmlFor="fri">금</label>
                        <input type="checkbox" className="chk_date" id="sat" />
                        <label htmlFor="sat">토</label>
                        <input type="checkbox" className="chk_date" id="sun" />
                        <label htmlFor="sun">일</label>
                      </div>
                      <div className="sel_time">
                        <select className="select">
                          <option value="08시">08시</option>
                        </select>
                        <select className="select">
                          <option value="08시">30분</option>
                        </select>
                        <span className="divider">~</span>
                        <select className="select">
                          <option value="08시">08시</option>
                        </select>
                        <select className="select">
                          <option value="08시">30분</option>
                        </select>
                      </div>
                      <button className="btn_add"></button>
                      <button className="btn_minus_gray"></button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>가능일 특이사항</th>
                  <td colSpan={3} className="td_left">
                    <input type="text" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="com_btn_wrap bottom">
        <button className="com_btn s full lightGray">+ 수업 추가 등록</button>
      </div>
      <PopClassHistory open={modalOpenClassHistory} close={() => setModalOpenClassHistory(false)} />
    </div>
  );
};
export default PopFinishReport;
